import { SurveyBlock } from '@/types/survey';

export function getStepTitles(survey?: Array<{ block: SurveyBlock[] }>): string[] {
    return (
        survey?.map((surveyItem) => {
            const titleBlock = surveyItem.block.find(
                (block) =>
                    block.fieldGroupName ===
                    'SitesContentSettings_Generaloptionssetting_wizardComponent_survey_Block_StepTitle',
            );
            return titleBlock && 'text' in titleBlock
                ? titleBlock.text || 'مرحله بدون عنوان'
                : 'مرحله بدون عنوان';
        }) ?? []
    );
}
